import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UsertokenService } from '../usertoken.service';
import { Api } from './api';

export const jwtFromUrlGuard: CanActivateFn = async (route, state) => {
  const api = inject(Api);
  const router = inject(Router);
  const usertokenService = inject(UsertokenService);

  const ut = route.queryParamMap.get("pkvut")

  if (usertokenService.isTokenValid(ut)) {
    usertokenService.setUserTokenAfterAuth("" + ut);
  }
  if (!usertokenService.hasValidToken()) {
    router.navigate(["/", "nologgedinuser"])
    return false;
  }

  const redirect = await api.getViewForApiResult();
  router.navigate(["/", redirect])
  return false
};